const useGetPopulateValue = (context: StepsFormContextValues, name: string) =>
  context?.populate[name] ?? null;
export default useGetPopulateValue;
